import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { getIframePageDecorators } from "../../../../shared/page";

interface TeaserHighlightTemplateProps {
    title: string;
    icon: string;
    ctaText: string;
    ctaLink: string;
    textWhite?: boolean;
    backgroundClass?: string;
}

const TeaserHighlightTemplate = ({
    title,
    icon,
    ctaText,
    ctaLink,
    textWhite,
    backgroundClass = "ux-u-background-grey",
}: TeaserHighlightTemplateProps) => {
    const classNames = ["ux-iws-teaser-highlight", backgroundClass];
    if (textWhite) {
        classNames.push("ux-iws-teaser-highlight--text-white");
    }
    return html`
        <div class="${classNames.join(" ")}">
            <div class="ux-iws-teaser-highlight__icon-container">
                <ux-icon name="${icon}"></ux-icon>
            </div>
            <h3
                class="ux-iws-teaser-highlight__title ux-text-headline ux-text-headline--giant"
            >
                ${title}
            </h3>
            <div class="ux-iws-teaser-highlight__cta-container">
                <a
                    href="${ctaLink}"
                    target="_blank"
                    class="ux-button ux-button--green"
                >
                    ${ctaText}
                </a>
            </div>
        </div>
    `;
};

export default {
    title: "Website/Partial Templates/Teaser/Highlight",
    render: TeaserHighlightTemplate.bind({}),
    decorators: getIframePageDecorators(),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    args: {
        title: "Highlight Topic Lorem ipsum Dolor",
        icon: "globe",
        ctaText: "Mehr erfahren",
        ctaLink: "#",
        textWhite: false,
        backgroundClass: "ux-u-background-grey",
    },
};

export const Default = {};

export const TextWhite = {
    args: {
        textWhite: true,
        backgroundClass: "ux-u-background-blue-faded-horizontal",
    },
};
